import {AfterViewInit, ChangeDetectorRef, Component, ElementRef, OnInit, Renderer2, ViewChild} from '@angular/core';
import {DynamicFormService} from '../../../dynamic-form/dynamic-form.service';
import {BaseFieldComponent} from '../../base/base-field/base-field.component';
import {EventDispatcherService} from '../../../events/event-dispatcher.service';
import {SlideToggleFieldConfig} from '../slide-toggle-field.config';
import {FormFieldComponent} from '@mydocma/component-library/src/lib/form';

@Component({
    selector: 'mydocma-form-slide-toggle-field',
    templateUrl: './slide-toggle-field.component.html',
    styleUrls: ['./slide-toggle-field.component.scss'],
    providers: []
})
export class SlideToggleFieldComponent extends BaseFieldComponent<SlideToggleFieldConfig> implements OnInit, AfterViewInit {
    public readonly staticCssClass = 'mydocma-slidetoggle-field';
    @ViewChild('field') slideToggleFieldComponent: FormFieldComponent;
    collapsed = false;

    constructor(
        public readonly dynamicFormService: DynamicFormService,
        public readonly changeDetectorRef: ChangeDetectorRef,
        public readonly eventDispatcher: EventDispatcherService,
        element: ElementRef,
        renderer: Renderer2,
    ) {
        super(dynamicFormService, changeDetectorRef, eventDispatcher, element, renderer);
    }

    ngOnInit() {
        super.ngOnInit();
    }


    public onClick() {
        super.onControlClick();
    }

    resize(event: { contentRect: { width: number; }; }) {

        const collapsed = (this.maxCollapsedWidth > event.contentRect.width);
        if (collapsed !== this.collapsed) {
            this.collapsed = collapsed;
            this.changeDetectorRef.detectChanges();
        }
    }

    ngAfterViewInit(): void {
        this.resize({contentRect: {width: this.slideToggleFieldComponent.currentWidth}})
    }
}
